export function target() {
  return this.module === 'PromoMulti' && !this.data.buttonLinks;
}

export function migrate() {
  const { groupDynamicLink, dynamicLink } = this.data;

  if (groupDynamicLink) {
    this.data.buttonLinks = 'group';
  } else if (dynamicLink) {
    this.data.buttonLinks = 'promo';
  } else {
    this.data.buttonLinks = 'lets';
  }

  delete this.data.groupDynamicLink;
  delete this.data.dynamicLink;
}
